import { theme } from "../../utils/theme";
import styled, { css } from 'styled-components';

export const Title = styled.h2`
  color: ${theme.colors.darkText};
  font-size: 1.5em;
  font-weight: 600;
  margin-bottom: ${theme.spacing(1)};
`;

export const Label = styled.label`
  display: block;
  text-align: left;
  color: ${theme.colors.darkText};
  font-weight: 500;
  font-size: 0.85em;
  margin-bottom: ${theme.spacing(1)};
  margin-top: ${theme.spacing(3)};
`;

const inputStyles = css`
  width: 100%;
  padding: ${theme.spacing(2)};
  border: 1px solid ${theme.colors.lightGrey};
  border-radius: 4px;
  font-size: 1em;
  box-sizing: border-box; /* Ensures padding doesn't increase total width */
  
  &:focus {
    border-color: ${theme.colors.primary};
    outline: none;
    box-shadow: 0 0 0 2px rgba(71, 149, 119, 0.2);
  }
`;

export const Input = styled.input`
  ${inputStyles}
`;

export const Button = styled.button`
  width: 100%;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  padding: ${theme.spacing(2)} 0;
  border: none;
  border-radius: 4px;
  font-size: 1.1em;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: ${theme.spacing(4)};
  
  &:hover {
    background-color: #3b7b62; /* Slightly darker shade for hover effect */
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const FormField = styled.div`
  margin-bottom: ${theme.spacing(2)};
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 0.8em;
  margin-top: ${theme.spacing(1)};
  text-align: left;
`;
